/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'ai-mate.agent-header-banner-label': 'Agentbanner',
  'ai-mate.agent-list.all-agents-section-title': 'Alle agenter',
  'ai-mate.agent-list.beta-lozenge-title': 'Beta',
  'ai-mate.agent-list.change-owner-success-flag-description': 'Du har ændret ejeren af {agentName} til {newOwnerName}',
  'ai-mate.agent-list.change-owner-success-flag-title': 'Ejeren blev ændret',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Er du sikker på, at du vil slette denne agent? Handlingen kan ikke fortrydes.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Vil du slette "{agentName}"?',
  'ai-mate.agent-list.delete-agent-error': 'Kunne ikke slette agenten',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    'Der gik noget galt under sletning af agenten. Prøv igen om et øjeblik.',
  'ai-mate.agent-list.delete-agent-error-flag-title': 'Kunne ikke slette agent',
  'ai-mate.agent-list.delete-agent-error.agent-in-use': 'Agenten er i brug i øjeblikket. Prøv igen senere.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'Agenten kunne ikke findes.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'Du kan ikke slette agenter, du ikke selv har oprettet. Kontakt ejeren af agenten.',
  'ai-mate.agent-list.delete-agent-success-flag-description': 'Du har slettet {agentName}',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Agent slettet',
  'ai-mate.agent-list.development-section-title': 'Udviklingsagenter',
  'ai-mate.agent-list.load-more-button-loading': 'Indlæser flere agenter …',
  'ai-mate.agent-list.load-more-button-ready': 'Indlæs mere',
  'ai-mate.agent-list.loading-agents': 'Indlæser agenter ...',
  'ai-mate.agent-list.no-results': 'Ingen resultater for "{searchValue}"',
  'ai-mate.agent-list.recommended-agents-section-title': 'Anbefalet',
  'ai-mate.agent-list.searching-agents': 'Søger efter agenter …',
  'ai-mate.agent-list.templates-description':
    'Brug disse skabeloner til at oprette din egen udvikleragent. Vælg den rigtige agentskabelon til dit arbejde, vælg Anvend skabelon, og udfyld derefter skabelonprompten med specifikke oplysninger som lager, mappe, sprog og bibliotek. Opret skræddersyede udviklingsagenter til kodning af forskellige opgaver, projekter eller lagre.',
  'ai-mate.agent-list.templates-lozenge-title': 'Skabelon',
  'ai-mate.agent-list.templates-title': 'Kodningsskabeloner',
  'ai-mate.agent-message.agent-not-found': 'Agenten blev ikke fundet',
  'ai-mate.agent-message.convo-title': 'Chat med {agentName} udløst fra indlejret intelligent link',
  'ai-mate.agent-message.copy-link': 'Kopiér agentlink',
  'ai-mate.agent-message.prompt': 'Prompt',
  'ai-mate.agent-message.prompt-placeholder': 'Skriv en besked til {agentName}',
  'ai-mate.agent-message.prompt-submit': 'Indsend',
  'ai-mate.agent-message.view-profile': 'Vis profil',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Annuller',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Slet',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agent · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Chat med {agentName}',
  'ai-mate.agent-profile-info.copy-agent-link-clicked-tooltip': 'URL blev kopieret',
  'ai-mate.agent-profile-info.copy-agent-link-tooltip': 'Kopiér link',
  'ai-mate.agent-profile-info.hidden-icon': 'Skjult',
  'ai-mate.agent-profile-info.hidden-tooltip': 'Agenten vises ikke i søgeresultaterne',
  'ai-mate.agent-profile-info.star-agent-tooltip': 'Stjernemarkér agent',
  'ai-mate.agent-selector.agent-not-found': 'Agenten blev ikke fundet',
  'ai-mate.agent-selector.default-agent-description': 'Få svar, generer nye idéer, og sæt fart på det daglige arbejde.',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'ai-mate.browse-agents-view.close-button': 'Luk agentvisning',
  'ai-mate.browse-agents.scenario-pill.default-scenario-tag': 'Standard',
  'ai-mate.browse-agents.scenario-pill.inactive-scenario-tooltip': 'Inaktiv',
  'ai-mate.profile-card-preview.actions-title': 'Handlinger',
  'ai-mate.profile-card-preview.agent-default-title': 'Agent',
  'ai-mate.profile-card-preview.agent-description-label': 'Beskrivelse',
  'ai-mate.profile-card-preview.agent-title-label': 'Titel',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Samtalestartere',
  'ai-mate.profile-card-preview.empty-actions': 'Ingen',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'Ingen',
  'ai-mate.profile-card-preview.empty-instructions': 'Ingen',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'Ingen er valgt',
  'ai-mate.profile-card-preview.instructions-title': 'Vejledning',
  'ai-mate.profile-card-preview.knowledge-title': 'Viden',
  'ai-mate.profile-card-preview.regenerate-label': 'Genskab {fieldName}',
  'conversation-assistant-agent.create-agent.agent-name-copy': 'Kopi af {agentName}',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': 'Træk for at omarrangere',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': 'Kunne ikke gemme ændringer',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Der opstod en ukendt fejl. Prøv igen',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'Der findes allerede en agent med det navn',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Fjern',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text': 'Generer samtalestartere',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {{fieldName} må højst indeholde {maxLength,number} tegn} other {{fieldName} må højst indeholde {maxLength,number} tegn}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Næste',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Genstart',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': 'Spring til manuel opsætning',
  'create-agent.owner-field.confirm-modal-cancel': 'Annuller',
  'create-agent.owner-field.confirm-modal-confirm': 'Ja, fortsæt',
  'create-agent.owner-field.confirm-modal-content':
    'Du er ved at ændre ejeren af denne agent til {name}. Hvis du gør det, kan du ikke længere redigere eller administrere agenten.',
  'create-agent.owner-field.confirm-modal-title': 'Du er ved at miste redigeringsadgang',
  'create-agent.owner-field.owner-description': 'Dette er den person, der kan redigere eller administrere agenten.',
  'create-agent.owner-field.owner-label': 'Ejer',
  'rovo-chat.agent-card.deactivated-name': '{name} (deaktiveret)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'For mange anmodninger. Vent et øjeblik.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Prøv igen',
  'rovo-chat.browse-agents.all-agents-button': 'Alle',
  'rovo-chat.browse-agents.close-button': 'Luk',
  'rovo-chat.browse-agents.create-agent-button': 'Opret',
  'rovo-chat.browse-agents.create-an-agent-button': 'Opret en agent',
  'rovo-chat.browse-agents.create-button-disabled-tooltip':
    'Du har ikke tilladelse til at oprette agenter på dette website',
  'rovo-chat.browse-agents.created-by-label': '<text>af</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Kodningsagenter',
  'rovo-chat.browse-agents.favorite-agents-button': 'Favoritter',
  'rovo-chat.browse-agents.favourited-agent-label': 'Favoritagent',
  'rovo-chat.browse-agents.modal-title': 'Gennemse agenter',
  'rovo-chat.browse-agents.my-agents-button': 'Mine agenter',
  'rovo-chat.browse-agents.no-created-agents':
    'Det ser ud til, at du ikke har oprettet nogen agenter endnu. Start med at duplikere andre eksisterende agenter, eller opret en fra bunden.',
  'rovo-chat.browse-agents.no-created-agents-header': 'Der er ikke oprettet nogen agenter endnu',
  'rovo-chat.browse-agents.no-created-agents-header-no-permission': 'Du har ikke oprettet nogen agenter',
  'rovo-chat.browse-agents.no-created-agents-no-permission':
    'Du skal have tilladelse fra en administrator for at oprette Rovo-agenter på dette website.',
  'rovo-chat.browse-agents.no-starred-agents':
    'Hvis du har en favoritagent eller en, som du bruger ofte, kan du stjernemarkere den, så du hurtigt kan tilgå den.',
  'rovo-chat.browse-agents.no-starred-agents-header': 'Du har ikke stjernemarkeret en agent endnu',
  'rovo-chat.browse-agents.search-input.placeholder': 'Søg efter agenter',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Søg i skabeloner',
  'rovo-chat.browse-agents.see-all-agents-button': 'Vis alle agenter',
  'rovo-chat.browse-agents.templates-button': 'Skabeloner',
  'rovo-chat.create-agent.actions-section-description':
    'Tilføj handlinger, så din agent kan udføre opgaver i Jira, Confluence og Jira Service Management. <link>Hvad er agenthandlinger?</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'Tilføj handlinger',
  'rovo-chat.create-agent.all-content-label': 'Alt indhold',
  'rovo-chat.create-agent.back-button': 'Gå tilbage',
  'rovo-chat.create-agent.beta-lozenge': 'Beta',
  'rovo-chat.create-agent.confirm-leave-modal.body': 'Du har ikke oprettet din agent endnu, vil du kassere den?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Annuller',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'Ja, kassér agent',
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Ufærdig agent',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    'Er du sikker på, du vil kassere de ændringer, du har foretaget til denne agent?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Bekræft',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Genstart din oprettelse',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'Folk kan bruge disse til at starte en chat med din agent. Hvis du ikke kan finde på nogen, kan vi generere dem for dig.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Samtalestartere',
  'rovo-chat.create-agent.create-agent-button': 'Opret',
  'rovo-chat.create-agent.ctions-section-title': 'Handlinger',
  'rovo-chat.create-agent.description-field-description':
    'Folk kan bruge beskrivelsen på agentens profil til at få mere at vide om agenten.',
  'rovo-chat.create-agent.description-field-label': 'Beskrivelse',
  'rovo-chat.create-agent.description-field-placeholder':
    'Skriv en kort beskrivelse af din agent (for eksempel kreativ forfatter af marketingblogs)',
  'rovo-chat.create-agent.instructions-field-description':
    'Hvordan vil du have, at denne agent skal opføre sig? Hvad kan den? <link>Få mere at vide om, hvordan du skriver instruktioner til en agent</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Vejledning',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Tilpas instruktionerne til denne agent',
  'rovo-chat.create-agent.intro-description-part-1':
    'Opret en agent med specialiseret viden til at besvare spørgsmål, skrive og gennemgå indhold og udføre opgaver, der hjælper dig med at komme videre med arbejdet.',
  'rovo-chat.create-agent.intro-description-part-2':
    'Hvis du ikke har brug for hjælp, kan du <bold>springe til manuel opsætning.</bold>',
  'rovo-chat.create-agent.intro-description-part-3': 'Ellers, bliv her, så kan vi generere en sammen.',
  'rovo-chat.create-agent.intro-step-1-content':
    'Jeg opretter instruktioner til agenten baseret på det, du skriver. Fortæl mig, hvad du planlægger at bruge agenten til.',
  'rovo-chat.create-agent.intro-step-1-title': 'Beskriv, hvad du vil have din agent til at gøre',
  'rovo-chat.create-agent.intro-step-2-content':
    'Lad os sammen vælge din agents navn og personlighed. Fortæl mig, om din agent er empatisk, direkte eller sjov.',
  'rovo-chat.create-agent.intro-step-2-title': 'Giv den lidt personlighed',
  'rovo-chat.create-agent.intro-step-3-content':
    'Tryk på <bold>Næste</bold> for at gennemgå din nye agent og tilføje handlinger, viden og et profilbillede. Når du er færdig, vælger du <bold>Opret.</bold>',
  'rovo-chat.create-agent.intro-step-3-content-skills':
    'Tryk på <bold>Næste</bold> for at gennemgå din nye agent og tilføje færdigheder, viden og et profilbillede. Når du er færdig, vælger du <bold>Opret.</bold>',
  'rovo-chat.create-agent.intro-step-3-title': 'Gennemgå, og opret din agent',
  'rovo-chat.create-agent.intro-title': '👋 Lad os oprette din agent',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'Alle projekter',
  'rovo-chat.create-agent.jira-filter-placeholder-galaxia': 'Alle områder',
  'rovo-chat.create-agent.jsm-checkbox-label': 'Jira Service Management',
  'rovo-chat.create-agent.jsm-filter-knowledge-base-placeholder': 'Søg efter vidensbase',
  'rovo-chat.create-agent.knowledge-field-description':
    'Angiv agentens viden ved kun at lade den henvise til de kilder, du angiver',
  'rovo-chat.create-agent.knowledge-field-label': 'Viden',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Henvis kun til disse kilder',
  'rovo-chat.create-agent.knowledge-select.object-resolver-label': 'Links',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Foreslået',
  'rovo-chat.create-agent.manage-actions-button-label': 'Administrer handlinger',
  'rovo-chat.create-agent.name-field-description': 'Folk kan bruge dette til at finde agenten.',
  'rovo-chat.create-agent.name-field-label': 'Navn',
  'rovo-chat.create-agent.name-field-placeholder': 'Navngiv din agent',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error': 'Der opstod en uventet fejl. Prøv igen.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    'Hej! Jeg er her for at hjælpe dig med at generere en brugerdefineret agent. Fortæl mig, hvad du vil have din agent til at gøre?',
  'rovo-chat.create-agent.nl-input-field.input-label': 'Opret en agent',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Skriv din meddelelse',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Send',
  'rovo-chat.create-agent.page-title': 'Opret en agent',
  'rovo-chat.create-agent.page-title-edit': 'Rediger agent',
  'rovo-chat.create-agent.search-for-pages-placeholder': 'Søg efter sider',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Søg efter områder',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'Alle',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Beta',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Annuller',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Luk',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, one {Hvis du vælger færre end {count,number} handling, opnår du optimal ydeevne} other {Hvis du vælger færre end {count,number} handlinger, opnår du optimal ydeevne}}',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Gem',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Søg i handlinger',
  'rovo-chat.create-agent.select-action-modal-title': 'Tilføj handlinger',
  'rovo-chat.create-agent.select-content-under-label': 'Vælg indhold under',
  'rovo-chat.create-agent.select-spaces-label': 'Vælg områder',
  'rovo-chat.create-agent.selected-actions-label': 'Udvalgte handlinger:',
  'rovo-chat.create-agent.unknown-owner': 'Ukendt',
  'rovo-chat.create-agent.update-agent-button': 'Opdater',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    'Hvis du fortsætter, mister du ændringer, der ikke er gemt. Vælg Annuller for at fortsætte med at redigere denne agent.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Fortsæt, og kassér ændringer',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Kassér ændringer',
  'rovo-chat.view-agent.about-label': 'Om',
  'rovo-chat.view-agent.actions-label': 'Handlinger',
  'rovo-chat.view-agent.agent-instructions.copy-label': 'Kopiér',
  'rovo-chat.view-agent.agent-instructions.copy-tooltip': 'Kopiér instruktioner',
  'rovo-chat.view-agent.agent-instructions.placeholder': 'Denne agent har ingen brugerdefinerede instruktioner',
  'rovo-chat.view-agent.all-knowledge-added': 'Al organisatorisk viden',
  'rovo-chat.view-agent.behaviour-label': 'Adfærd',
  'rovo-chat.view-agent.beta-label': 'Beta',
  'rovo-chat.view-agent.beta-tag': 'Beta',
  'rovo-chat.view-agent.chat-to-agent-button': 'Chat med agent',
  'rovo-chat.view-agent.close-button': 'Luk',
  'rovo-chat.view-agent.copied-instructions-tooltip-label': 'Kopieret',
  'rovo-chat.view-agent.copy-instructions-tooltip-label': 'Kopiér',
  'rovo-chat.view-agent.created-by-label': '<text>af</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': 'Antal favoritter',
  'rovo-chat.view-agent.go-back-label': 'Gå tilbage',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Instruktioner til Forge-agenter, der er genereret med kode, er skjult af anonymitetsmæssige hensyn.',
  'rovo-chat.view-agent.hidden-instructions-title': 'Disse instruktioner er private',
  'rovo-chat.view-agent.hidden-knowledge-description':
    'Forge-agenter, der er genereret med kode, bruger ikke de typiske kilder til viden',
  'rovo-chat.view-agent.inactive-action-tooltip': 'Inaktiv',
  'rovo-chat.view-agent.instructions-label': 'Vejledning',
  'rovo-chat.view-agent.knowledge-label': 'Viden',
  'rovo-chat.view-agent.member-count': '{count, plural, one {{count,number} medlem} other {{count,number} medlemmer}}',
  'rovo-chat.view-agent.modal-title': 'Gennemse agenter',
  'rovo-chat.view-agent.no-actions': 'Ingen handlinger',
  'rovo-chat.view-agent.no-behaviour-placeholder': 'Denne agent har ingen brugerdefineret adfærd',
  'rovo-chat.view-agent.no-instruction-placeholder': 'Denne agent har ingen brugerdefinerede instruktioner',
  'rovo-chat.view-agent.no-knowledge-added': 'Ingen organisatorisk viden',
  'rovo-chat.view-agent.no-scenarios': 'Ingen scenarier',
  'rovo-chat.view-agent.no-skills': 'Ingen færdigheder',
  'rovo-chat.view-agent.no-teams': 'Ikke en del af et team',
  'rovo-chat.view-agent.open-chat-label': 'Åbn chat',
  'rovo-chat.view-agent.reactions-metadata-label': 'Antal reaktioner',
  'rovo-chat.view-agent.rovo-agent-label': 'Rovo-agent',
  'rovo-chat.view-agent.scenarios-label': 'Scenarier',
  'rovo-chat.view-agent.skills-label': 'Færdigheder',
  'rovo-chat.view-agent.teams-label': 'Teams',
  'rovo-chat.view-agent.users-metadata-label': 'Antal brugere',
  'rovo.agent.scenarios.scenarioModal.actionsLabel': 'Handlinger',
  'rovo.agent.scenarios.scenarioModal.instructionsLabel': 'Instruktioner',
  'rovo.agent.scenarios.scenarioModal.knowledgeSourcesLabel': 'Viden',
  'rovo.agent.scenarios.scenarioModal.mcpServersLabel': 'MCP-servere',
  'rovo.agent.scenarios.scenarioModal.noActions': 'Ingen handlinger',
  'rovo.agent.scenarios.scenarioModal.noInstructions': 'Ingen instruktioner',
  'rovo.agent.scenarios.scenarioModal.noMcpServers': 'Ingen MCP-servere',
  'rovo.agent.scenarios.scenarioModal.noSkills': 'Ingen færdigheder',
  'rovo.agent.scenarios.scenarioModal.skillsLabel': 'Færdigheder',
  'rovo.conversation.assistant.agent.deepResearchPill': 'Dyb forskning',
};
